import { useEffect } from 'react'
import { Navigate, Routes } from 'react-router'
import { useDispatch } from 'react-redux';
import { logoutSession } from '../../redux/auth/authSlice';
import { AppDispatch } from '../../redux/store';

export function Logout() {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(logoutSession());
  }, [dispatch])

  return (
    <Routes>
      <Navigate to='/auth/login' />
    </Routes>
  )
}
